import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    list: {
        url: `${customerApi}/api/duplicated_customers`,
        type: 'GET',
    },
    followUsers: {
        url: `${customerApi}/api/duplicated_customers/{external_userid}/follow_users`,
        type: 'GET',
    },
}
